import { useState , useEffect } from 'react';
import errorIcon from 'assets/img/error-icon.svg';
import successIcon from 'assets/img/verifica.png';
import iconregalo from 'assets/img/iconregalo.svg';
import addIcon from 'assets/img/regalo-agregado.svg';
import { useStore } from 'store';
import ModalProductTC from '../../Modal'
import styles from '../styles.module.sass'

const ProductsSuccessAdd = (props) => {
    const {
        success,
        setSuccess,
        successStore,
        setSuccessStore,
        errorProduct,
        setErrorProduct,
        resettUrl,
        typeModal = 'base',
        responseTable,
        type = 1
    } = props

    const [ giftTable ] = useStore((state) => state.giftTable.giftTable);
    const isMobile = 'desktop'
    const [ title, setTitle ] = useState('Artículo agregado')
    const [ message, setMessage  ] = useState('El producto fue agregado a la mesa de regalos')
    const [ idTable, setIdTable ] = useState(null)
    const [ imageURL, setImageURL ] = useState(successIcon)
    const [ showModal, setsShowModal ] = useState(false)

    const handleClose = () => {
        resettUrl()
        setsShowModal(false)
        setSuccess(false)
        setSuccessStore(false)
        setErrorProduct(false)
    }

    useEffect(()=>{
        if(success){
            if(type === 1){
                setsShowModal(true)
                setTitle('Artículo agregado')
                setMessage('El producto fue agregado a la mesa de regalos')
                setImageURL(successIcon)
            }
            else if(type === 2){
                setsShowModal(true)
                setTitle('Artículo agregado')
                setMessage('El producto fue agregado a la mesa de regalos')
                setImageURL(addIcon)
            }
        }
    },[success])

    useEffect(()=>{
        if(successStore){
            setsShowModal(true)
            setTitle('Artículo agregado')
            setMessage('El producto fue agregado a la mesa de regalos')
        }
    },[successStore])
    
    useEffect(()=>{
        if(errorProduct){
            setsShowModal(true)
            setTitle('Artículo no encontrado')
            setMessage('El producto no existe para venta en internet o esta agotado')
            setImageURL(errorIcon)
        }
    },[errorProduct])

    useEffect(()=>{
        if(giftTable){
            if(success){
                setIdTable(giftTable?.id)
            }
            if(typeModal === 'agregasRegalos'){
                const festefados = giftTable?.celebrate_labels?.length > 1 ? `${giftTable?.celebrate_labels[0]?.label?.value} & ${giftTable?.celebrate_labels[1]?.label?.value}` : giftTable?.celebrate_labels?.length === 1 ? `${giftTable?.celebrate_labels[0]?.label?.value}` : null
                setIdTable(festefados)
            }
        }
    },[giftTable])

    return(
        showModal
            ? 
                <ModalProductTC
                    onClose={handleClose} 
                    isMobile={isMobile} 
                    type={isMobile === 'desktop' ? '' : 'full'} 
                    title={title} 
                    closeBody="modalPromos"
                >
                    <ModalSuccess 
                        title={title}
                        message={message}
                        imageURL={imageURL}
                        idTable={idTable}
                        type={type}
                        handleClose={handleClose}
                        success={success || successStore}
                        typeModal={typeModal}
                    />
                </ModalProductTC>
            : null
    )
}

const ModalSuccess = (props) => {
    const {
        title,
        imageURL,
        message,
        idTable,
        type = 1,
        handleClose,
        success,
        typeModal
    } = props

    return(
        <div className={styles?.successModalProduct}>
            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
            {typeModal === 'base'
                ? <img className={styles?.iconSuccess} src={success ? successIcon : errorIcon} alt={title} />
                : null
            }
            {typeModal === 'agregasRegalos'
                ? <img className={styles?.iconSuccess} src={iconregalo} alt={title} />
                : null
            }
            <p className={styles?.title}>{title}</p>
            <p className={styles?.message}>{message}</p>
            {typeModal === 'base'
                ? idTable
                    ? <p className={styles?.idTable}>#{idTable}</p>
                    : null
                : null    
            }
            {typeModal === 'agregasRegalos'
                ? idTable
                    ? <p className={styles?.agregasRegalos}>{idTable}</p>
                    : null
                : null    
            }
            <div onClick={handleClose} className={`btn primaryButton ${styles?.btnprimary}`} aria-hidden>Aceptar</div>
        </div>
    )
}

export default ProductsSuccessAdd